export const OVERLAY_SHOWN = "overlayshown";
export const OVERLAY_HIDDEN = "hidden";
export const SEARCH_REQUEST_COMPLETE = "searchrequestcomplete";
